import { createAction } from '@reduxjs/toolkit';
import { RecordingStartedPayload } from 'features/room/types';
import {
  Recorder,
  RecordingFailurePayload,
  RecordingStopRequestedPayload,
} from 'features/recorder/types';

export const recordingToggled = createAction<boolean | undefined>('recorder/recordingToggled');

export const requestRecording = createAction('recorder/request');
export const signalingRecordingRequested = createAction('signaling/recorder/requested');
export const signalingRecordingStarted = createAction<RecordingStartedPayload>(
  'signaling/recorder/started'
);

export const stopRecorder = createAction('recorder/stop');
export const signalingRecordingStopRequested = createAction<
  RecordingStopRequestedPayload | undefined
>('signaling/recorder/stopRequested');
export const signalingRecordingFailed = createAction<RecordingFailurePayload | undefined>(
  'signaling/recorder/failed'
);
export const signalingRecordingStopped = createAction('signaling/recorder/stopped');

export const signalingRecorderJoined = createAction<Recorder>('signaling/recorder/joined');

export const createRecordingBookmarkRequested = createAction<{ bookmark: string }>(
  'recorder/createBookmarkRequested'
);
export const signalingRecordingBookmarkCreated = createAction<{ bookmark: string }>(
  'signaling/recorder/bookmarkCreated'
);
